import { PDFReportType } from 'modules/productAnalytics/types';
import { post } from 'services/api';

const REPORT_URL = '/analytics/generate-report';

export interface PDFReportQuery {
  type: PDFReportType;
  [key: string]: any; // Allow any optional attributes
}

export const getPDFReport = (query: PDFReportQuery) =>
  post(REPORT_URL, query, { responseType: 'arraybuffer' });
